
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class InstructionTaskMapDialog extends SiteEntityDialog<InstructionTaskMapRow, any> {
        protected getFormKey() { return InstructionTaskMapForm.formKey; }
        protected getIdProperty() { return InstructionTaskMapRow.idProperty; }
        protected getLocalTextPrefix() { return InstructionTaskMapRow.localTextPrefix; }
        protected getNameProperty() { return InstructionTaskMapRow.nameProperty; }
        protected getService() { return InstructionTaskMapService.baseUrl; }

        protected form = new InstructionTaskMapForm(this.idPrefix);
    }
}